module.exports = __webpack_public_path__ + "static/media/flag-il.2d7ed5d5.svg";